import Colors from '../../../../shared/assets/style/default/color';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import { ProgressBarFillProps as Props } from '../../../../shared/types/props/progressBar';

/**
 * Styled component for the progress bar fill indicator.
 * Displays the progress percentage with customizable color (default green, red for live, or custom).
 *
 * @param {Props} props - Progress bar fill props including value, fillRed, and customColor
 */
const ProgressBarFill = styled.div.attrs((props: Props) => {
  const { fillRed, value, customColor } = props;
  return {
    style: {
      background: customColor
        ? customColor
        : fillRed
        ? Colors['progress']['live']
        : Colors['progress']['fill'],
      width: `${value}%`,
    },
  };
})<Props>`
  border-radius: ${5 * Screen.widthRatio}px 0 0 ${5 * Screen.widthRatio}px;
  height: ${12 * Screen.widthRatio}px;
  position: inherit;
  width: 100%;
  transition: ${(props) => props.transition || 'none'};
`;

export default ProgressBarFill;
